// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../node_modules/rescript/lib/es6/js_dict.js";

function customer_encode(v) {
  return Js_dict.fromArray([
              [
                "mobile",
                Decco.stringToJson(v.mobile)
              ],
              [
                "first_name",
                Decco.stringToJson(v.first_name)
              ],
              [
                "last_name",
                Decco.stringToJson(v.last_name)
              ],
              [
                "geo_region_id",
                Decco.intToJson(v.geo_region_id)
              ],
              [
                "frequency",
                Decco.stringToJson(v.frequency)
              ]
            ]);
}

function t_encode(v) {
  return Js_dict.fromArray([[
                "customer",
                customer_encode(v.customer)
              ]]);
}

export {
  customer_encode ,
  t_encode ,
  
}
/* No side effect */
